function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e6) { throw _e6; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e7) { didErr = true; err = _e7; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!
/**
* Highcharts JS v12.1.2 (2024-12-21)
* @module highcharts/modules/drilldown
* @requires highcharts
*
* Highcharts Drilldown module
*
* Author: Torstein Honsi
* License: www.highcharts.com/license
*
*/
function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(t._Highcharts, t._Highcharts.Templating, t._Highcharts.Color) : "function" == typeof define && define.amd ? define("highcharts/modules/drilldown", ["highcharts/highcharts"], function (t) {
    return e(t, t.Templating, t.Color);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["highcharts/modules/drilldown"] = e(t._Highcharts, t._Highcharts.Templating, t._Highcharts.Color) : t.Highcharts = e(t.Highcharts, t.Highcharts.Templating, t.Highcharts.Color);
}("undefined" == typeof window ? this : window, function (t, e, i) {
  return function () {
    "use strict";

    var o,
        l = {
      620: function _(t) {
        t.exports = i;
      },
      984: function _(t) {
        t.exports = e;
      },
      944: function _(e) {
        e.exports = t;
      }
    },
        r = {};

    function s(t) {
      var e = r[t];
      if (void 0 !== e) return e.exports;
      var i = r[t] = {
        exports: {}
      };
      return l[t](i, i.exports, s), i.exports;
    }

    s.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return s.d(e, {
        a: e
      }), e;
    }, s.d = function (t, e) {
      for (var i in e) {
        s.o(e, i) && !s.o(t, i) && Object.defineProperty(t, i, {
          enumerable: !0,
          get: e[i]
        });
      }
    }, s.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    var n = {};
    s.d(n, {
      default: function _default() {
        return tx;
      }
    });
    var a = s(944),
        d = s.n(a);
    var p = {
      lang: {
        mainBreadcrumb: "Main"
      },
      options: {
        buttonTheme: {
          fill: "none",
          height: 18,
          padding: 2,
          "stroke-width": 0,
          zIndex: 7,
          states: {
            select: {
              fill: "none"
            }
          },
          style: {
            color: "#334eff"
          }
        },
        buttonSpacing: 5,
        floating: !1,
        format: void 0,
        relativeTo: "plotBox",
        rtl: !1,
        position: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: void 0
        },
        separator: {
          text: "/",
          style: {
            color: "#666666",
            fontSize: "0.8em"
          }
        },
        showFullPath: !0,
        style: {},
        useHTML: !1,
        zIndex: 7
      }
    };
    var h = s(984);

    var _s$n = s.n(h)(),
        u = _s$n.format,
        _d = d(),
        c = _d.composed,
        _d2 = d(),
        m = _d2.addEvent,
        w = _d2.defined,
        g = _d2.extend,
        f = _d2.fireEvent,
        b = _d2.isString,
        v = _d2.merge,
        y = _d2.objectEach,
        x = _d2.pick,
        D = _d2.pushUnique;

    function S() {
      if (this.breadcrumbs) {
        var _t = this.resetZoomButton && this.resetZoomButton.getBBox(),
            _e = this.breadcrumbs.options;

        _t && "right" === _e.position.align && "plotBox" === _e.relativeTo && this.breadcrumbs.alignBreadcrumbsGroup(-_t.width - _e.buttonSpacing);
      }
    }

    function B() {
      this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
    }

    function L() {
      var t = this.breadcrumbs;

      if (t && !t.options.floating && t.level) {
        var _e2 = t.options,
            _i = _e2.buttonTheme,
            _o = (_i.height || 0) + 2 * (_i.padding || 0) + _e2.buttonSpacing,
            _l = _e2.position.verticalAlign;

        "bottom" === _l ? (this.marginBottom = (this.marginBottom || 0) + _o, t.yOffset = _o) : "middle" !== _l ? (this.plotTop += _o, t.yOffset = -_o) : t.yOffset = void 0;
      }
    }

    function O() {
      this.breadcrumbs && this.breadcrumbs.redraw();
    }

    function A(t) {
      !0 === t.resetSelection && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
    }

    var T = /*#__PURE__*/function () {
      function T(t, e) {
        _classCallCheck(this, T);

        this.elementList = {}, this.isDirty = !0, this.level = 0, this.list = [];
        var i = v(t.options.drilldown && t.options.drilldown.drillUpButton, T.defaultOptions, t.options.navigation && t.options.navigation.breadcrumbs, e);
        this.chart = t, this.options = i || {};
      }

      _createClass(T, [{
        key: "updateProperties",
        value: function updateProperties(t) {
          this.setList(t), this.setLevel(), this.isDirty = !0;
        }
      }, {
        key: "setList",
        value: function setList(t) {
          this.list = t;
        }
      }, {
        key: "setLevel",
        value: function setLevel() {
          this.level = this.list.length && this.list.length - 1;
        }
      }, {
        key: "getLevel",
        value: function getLevel() {
          return this.level;
        }
      }, {
        key: "getButtonText",
        value: function getButtonText(t) {
          var e = this.chart,
              i = this.options,
              o = e.options.lang,
              l = x(i.format, i.showFullPath ? "{level.name}" : "← {level.name}"),
              r = o && x(o.drillUpText, o.mainBreadcrumb),
              s = i.formatter && i.formatter(t) || u(l, {
            level: t.levelOptions
          }, e) || "";
          return (b(s) && !s.length || "← " === s) && w(r) && (s = i.showFullPath ? r : "← " + r), s;
        }
      }, {
        key: "redraw",
        value: function redraw() {
          this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
        }
      }, {
        key: "render",
        value: function render() {
          var t = this.chart,
              e = this.options;
          !this.group && e && (this.group = t.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({
            zIndex: e.zIndex
          }).add()), e.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
        }
      }, {
        key: "renderFullPathButtons",
        value: function renderFullPathButtons() {
          this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
        }
      }, {
        key: "renderSingleButton",
        value: function renderSingleButton() {
          var t = this.chart,
              e = this.list,
              i = this.options.buttonSpacing;
          this.destroyListElements();
          var o = this.group ? this.group.getBBox().width : i,
              l = e[e.length - 2];
          !t.drillUpButton && this.level > 0 ? t.drillUpButton = this.renderButton(l, o, i) : t.drillUpButton && (this.level > 0 ? this.updateSingleButton() : this.destroySingleButton());
        }
      }, {
        key: "alignBreadcrumbsGroup",
        value: function alignBreadcrumbsGroup(t) {
          if (this.group) {
            var _e3 = this.options,
                _i2 = _e3.buttonTheme,
                _o2 = _e3.position,
                _l2 = "chart" === _e3.relativeTo || "spacingBox" === _e3.relativeTo ? void 0 : "plotBox",
                _r = this.group.getBBox(),
                _s = 2 * (_i2.padding || 0) + _e3.buttonSpacing;

            _o2.width = _r.width + _s, _o2.height = _r.height + _s;

            var _n = v(_o2);

            t && (_n.x += t), this.options.rtl && (_n.x += _o2.width), _n.y = x(_n.y, this.yOffset, 0), this.group.align(_n, !0, _l2);
          }
        }
      }, {
        key: "renderButton",
        value: function renderButton(t, e, i) {
          var o = this,
              l = this.chart,
              r = o.options,
              s = v(r.buttonTheme),
              n = l.renderer.button(o.getButtonText(t), e, i, function (e) {
            var i;
            var l = r.events && r.events.click;
            l && (i = l.call(o, e, t)), !1 !== i && (r.showFullPath ? e.newLevel = t.level : e.newLevel = o.level - 1, f(o, "up", e));
          }, s).addClass("highcharts-breadcrumbs-button").add(o.group);
          return l.styledMode || n.attr(r.style), n;
        }
      }, {
        key: "renderSeparator",
        value: function renderSeparator(t, e) {
          var i = this.chart,
              o = this.options.separator,
              l = i.renderer.label(o.text, t, e, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group);
          return i.styledMode || l.css(o.style), l;
        }
      }, {
        key: "update",
        value: function update(t) {
          v(!0, this.options, t), this.destroy(), this.isDirty = !0;
        }
      }, {
        key: "updateSingleButton",
        value: function updateSingleButton() {
          var t = this.chart,
              e = this.list[this.level - 1];
          t.drillUpButton && t.drillUpButton.attr({
            text: this.getButtonText(e)
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
        }
      }, {
        key: "destroyListElements",
        value: function destroyListElements(t) {
          var e = this.elementList;
          y(e, function (i, o) {
            (t || !e[o].updated) && ((i = e[o]).button && i.button.destroy(), i.separator && i.separator.destroy(), delete i.button, delete i.separator, delete e[o]);
          }), t && (this.elementList = {});
        }
      }, {
        key: "destroySingleButton",
        value: function destroySingleButton() {
          this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
        }
      }, {
        key: "resetElementListState",
        value: function resetElementListState() {
          y(this.elementList, function (t) {
            t.updated = !1;
          });
        }
      }, {
        key: "updateListElements",
        value: function updateListElements() {
          var t = this.elementList,
              e = this.options.buttonSpacing,
              i = this.list,
              o = this.options.rtl,
              l = o ? -1 : 1,
              r = function r(t, e) {
            return l * t.getBBox().width + l * e;
          },
              s = function s(t, e, i) {
            t.translate(e - t.getBBox().width, i);
          },
              n = this.group ? r(this.group, e) : e,
              a,
              d;

          for (var _p = 0, _h = i.length; _p < _h; ++_p) {
            var _u = void 0,
                _c = void 0;

            var _m = _p === _h - 1;

            t[(d = i[_p]).level] ? (_u = (a = t[d.level]).button, a.separator || _m ? a.separator && _m && (a.separator.destroy(), delete a.separator) : (n += l * e, a.separator = this.renderSeparator(n, e), o && s(a.separator, n, e), n += r(a.separator, e)), t[d.level].updated = !0) : (_u = this.renderButton(d, n, e), o && s(_u, n, e), n += r(_u, e), _m || (_c = this.renderSeparator(n, e), o && s(_c, n, e), n += r(_c, e)), t[d.level] = {
              button: _u,
              separator: _c,
              updated: !0
            }), _u && _u.setState(_m ? 2 : 0);
          }
        }
      }], [{
        key: "compose",
        value: function compose(t, e) {
          D(c, "Breadcrumbs") && (m(t, "destroy", B), m(t, "afterShowResetZoom", S), m(t, "getMargins", L), m(t, "redraw", O), m(t, "selection", A), g(e.lang, p.lang));
        }
      }]);

      return T;
    }();

    T.defaultOptions = p.options;
    var C = s(620),
        E = s.n(C);

    var P = {
      activeAxisLabelStyle: {
        cursor: "pointer",
        color: "#0022ff",
        fontWeight: "bold",
        textDecoration: "underline"
      },
      activeDataLabelStyle: {
        cursor: "pointer",
        color: "#0022ff",
        fontWeight: "bold",
        textDecoration: "underline"
      },
      animation: {
        duration: 500
      },
      drillUpButton: {
        position: {
          align: "right",
          x: -10,
          y: 10
        }
      },
      mapZooming: !0
    },
        _d3 = d(),
        M = _d3.animObject,
        _d4 = d(),
        I = _d4.addEvent,
        V = _d4.extend,
        k = _d4.fireEvent,
        _ = _d4.merge,
        Z = _d4.pick,
        G = _d4.syncTimeout;

    function N(t, e, i, o) {
      t[i ? "addClass" : "removeClass"]("highcharts-drilldown-point"), o || t.css({
        cursor: e
      });
    }

    function U(t) {
      var e = this,
          i = e.chart,
          o = i.drilldownLevels,
          l = M((i.options.drilldown || {}).animation),
          r = this.xAxis,
          s = i.styledMode;

      if (!t) {
        var _t2;

        (o || []).forEach(function (i) {
          e.options._ddSeriesId === i.lowerSeriesOptions._ddSeriesId && (_t2 = i.shapeArgs, !s && _t2 && (_t2.fill = i.color));
        }), _t2.x += Z(r.oldPos, r.pos) - r.pos, e.points.forEach(function (i) {
          var o = i.shapeArgs;
          s || (o.fill = i.color), i.graphic && i.graphic.attr(_t2).animate(V(i.shapeArgs, {
            fill: i.color || e.color
          }), l);
        }), i.drilldown && i.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate;
      }
    }

    function j(t) {
      var e = this,
          i = M((e.chart.options.drilldown || {}).animation);
      (e.trackerGroups || []).forEach(function (t) {
        e[t] && e[t].on("mouseover");
      });
      var o = e.group,
          l = o !== e.chart.columnGroup;
      l && delete e.group, this.points.forEach(function (r) {
        var s = r.graphic,
            n = t.shapeArgs;

        if (s && n) {
          var _a = function _a() {
            s.destroy(), o && l && (o = o.destroy());
          };

          delete r.graphic, e.chart.styledMode || (n.fill = t.color), i.duration ? s.animate(n, _(i, {
            complete: _a
          })) : (s.attr(n), _a());
        }
      });
    }

    function F(t) {
      var e = this,
          i = e.drilldownLevel;
      t || (e.points.forEach(function (t) {
        var _e$connector;

        var e = t.dataLabel;
        t.graphic && t.graphic.hide(), e && (e.hidden = "hidden" === e.attr("visibility"), e.hidden || (e.hide(), (_e$connector = e.connector) === null || _e$connector === void 0 ? void 0 : _e$connector.hide()));
      }), G(function () {
        if (e.points) {
          var _t3 = [];
          e.data.forEach(function (e) {
            _t3.push(e);
          }), e.nodes && (_t3 = _t3.concat(e.nodes)), _t3.forEach(function (t, e) {
            var _l$connector;

            var o = e === (i && i.pointIndex) ? "show" : "fadeIn",
                l = t.dataLabel;
            t.graphic && t.visible && t.graphic[o]("show" === o || void 0), l && !l.hidden && (l.fadeIn(), (_l$connector = l.connector) === null || _l$connector === void 0 ? void 0 : _l$connector.fadeIn());
          });
        }
      }, Math.max(e.chart.options.drilldown.animation.duration - 50, 0)), delete this.animate);
    }

    function H(t) {
      var e = this,
          i = e.chart,
          o = e.group;
      i && o && e.options && i.options.drilldown && i.options.drilldown.animation && (t && i.mapView ? (o.attr({
        opacity: .01
      }), i.mapView.allowTransformAnimation = !1, e.options.inactiveOtherPoints = !0, e.options.enableMouseTracking = !1) : (o.animate({
        opacity: 1
      }, i.options.drilldown.animation, function () {
        e.options && (e.options.inactiveOtherPoints = !1, e.options.enableMouseTracking = Z(e.userOptions && e.userOptions.enableMouseTracking, !0));
      }), i.drilldown && i.drilldown.fadeInGroup(this.dataLabelsGroup)));
    }

    function z() {
      var t = this.chart;
      t && t.mapView && (t.mapView.allowTransformAnimation = !1), this.options && (this.options.inactiveOtherPoints = !0);
    }

    function R(t) {
      var e = this.chart,
          i = this.group;
      e && i && (t ? (i.attr({
        opacity: .01
      }), this.options && (this.options.inactiveOtherPoints = !0)) : (i.animate({
        opacity: 1
      }, (e.options.drilldown || {}).animation), e.drilldown && e.drilldown.fadeInGroup(this.dataLabelsGroup)));
    }

    function W() {
      return this.drilldown && !this.unbindDrilldownClick && (this.unbindDrilldownClick = I(this, "click", J)), this;
    }

    function q() {
      var t = this.series,
          e = t.chart.styledMode;
      this.drilldown && t.halo && "hover" === this.state ? N(t.halo, "pointer", !0, e) : t.halo && N(t.halo, "auto", !1, e);
    }

    function J(t) {
      var e = this.series;
      e.xAxis && !1 === (e.chart.options.drilldown || {}).allowPointDrilldown ? e.xAxis.drilldownCategory(this.x, t) : this.runDrilldown(void 0, void 0, t);
    }

    function K(t) {
      var e = t.options || {};
      e.drilldown && !this.unbindDrilldownClick ? this.unbindDrilldownClick = I(this, "click", J) : !e.drilldown && void 0 !== e.drilldown && this.unbindDrilldownClick && (this.unbindDrilldownClick = this.unbindDrilldownClick());
    }

    function Q() {
      var t = this.chart,
          e = t.options.drilldown.activeDataLabelStyle,
          i = t.renderer,
          o = t.styledMode;

      var _iterator = _createForOfIteratorHelper(this.points),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t4 = _step.value;

          var _l3 = _t4.options.dataLabels,
              _r2 = Z(_t4.dlOptions, _l3 && _l3.style, {});

          _t4.drilldown && _t4.dataLabel && ("contrast" !== e.color || o || (_r2.color = i.getContrast(_t4.color || this.color)), _l3 && _l3.color && (_r2.color = _l3.color), _t4.dataLabel.addClass("highcharts-drilldown-data-label"), o || _t4.dataLabel.css(e).css(_r2));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    function X() {
      var t = this.chart.styledMode;

      var _iterator2 = _createForOfIteratorHelper(this.points),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e4 = _step2.value;
          _e4.drilldown && _e4.graphic && N(_e4.graphic, "pointer", !0, t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    function Y(t) {
      var e = this.chart,
          i = this.points,
          o = e.drilldownLevels[e.drilldownLevels.length - 1],
          l = e.options.drilldown.animation;

      if (this.is("item") && (l.duration = 0), this.center) {
        var _r3 = o.shapeArgs,
            _s2 = _r3.start,
            _n2 = (_r3.end - _s2) / this.points.length,
            _a2 = e.styledMode;

        if (!t) {
          var _t5, _d5;

          for (var _e5 = 0, _p2 = i.length; _e5 < _p2; ++_e5) {
            _t5 = (_d5 = i[_e5]).shapeArgs, _a2 || (_r3.fill = o.color, _t5.fill = _d5.color), _d5.graphic && _d5.graphic.attr(_(_r3, {
              start: _s2 + _e5 * _n2,
              end: _s2 + (_e5 + 1) * _n2
            }))[l ? "animate" : "attr"](_t5, l);
          }

          e.drilldown && e.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate;
        }
      }
    }

    function $() {
      this.runDrilldown();
    }

    function tt(t, e, i) {
      var o = this.series,
          l = o.chart,
          r = l.options.drilldown || {},
          s = (r.series || []).length,
          n;

      for (l.ddDupes || (l.ddDupes = []), l.colorCounter = l.symbolCounter = 0; s-- && !n;) {
        r.series && r.series[s].id === this.drilldown && this.drilldown && -1 === l.ddDupes.indexOf(this.drilldown) && (n = r.series[s], l.ddDupes.push(this.drilldown));
      }

      k(l, "drilldown", {
        point: this,
        seriesOptions: n,
        category: e,
        originalEvent: i,
        points: void 0 !== e && o.xAxis.getDDPoints(e).slice(0)
      }, function (e) {
        var i = e.point.series && e.point.series.chart,
            o = e.seriesOptions;
        i && o && (t ? i.addSingleSeriesAsDrilldown(e.point, o) : i.addSeriesAsDrilldown(e.point, o));
      });
    }

    var te = {
      compose: function compose(t, e) {
        var i = t.prototype.pointClass,
            o = i.prototype;

        if (!o.doDrilldown) {
          var _l4 = e.column,
              _r4 = e.map,
              _s3 = e.pie;

          if (I(i, "afterInit", W), I(i, "afterSetState", q), I(i, "update", K), o.doDrilldown = $, o.runDrilldown = tt, I(t, "afterDrawDataLabels", Q), I(t, "afterDrawTracker", X), _l4) {
            var _t6 = _l4.prototype;
            _t6.animateDrilldown = U, _t6.animateDrillupFrom = j, _t6.animateDrillupTo = F;
          }

          if (_r4) {
            var _t7 = _r4.prototype;
            _t7.animateDrilldown = H, _t7.animateDrillupFrom = z, _t7.animateDrillupTo = R;
          }

          if (_s3) {
            var _t8 = _s3.prototype;
            _t8.animateDrilldown = Y, _t8.animateDrillupFrom = j, _t8.animateDrillupTo = F;
          }
        }
      }
    },
        _d6 = d(),
        ti = _d6.animObject,
        _d7 = d(),
        to = _d7.noop,
        _d8 = d(),
        tl = _d8.addEvent,
        tr = _d8.defined,
        ts = _d8.diffObjects,
        tn = _d8.extend,
        ta = _d8.fireEvent,
        td = _d8.merge,
        tp = _d8.objectEach,
        th = _d8.pick,
        tu = _d8.removeEvent,
        tc = _d8.syncTimeout,
        tm = 1;

    function tw(t, e) {
      this.getDDPoints(t).forEach(function (i) {
        i && i.series && i.series.visible && i.runDrilldown && i.runDrilldown(!0, t, e);
      }), this.chart.applyDrilldown();
    }

    function tg(t) {
      return this.ddPoints && this.ddPoints[t] || [];
    }

    function tf(t) {
      var e = [],
          i = t.drilldownLevels;
      return i && i.length && (e[0] || e.push({
        level: 0,
        levelOptions: i[0].seriesOptions
      }), i.forEach(function (t) {
        var i = e[e.length - 1];
        t.levelNumber + 1 > i.level && e.push({
          level: t.levelNumber + 1,
          levelOptions: td({
            name: t.lowerSeries.name
          }, t.pointOptions)
        });
      })), e;
    }

    var tb = /*#__PURE__*/function () {
      function tb(t) {
        _classCallCheck(this, tb);

        this.chart = t;
      }

      _createClass(tb, [{
        key: "addSeriesAsDrilldown",
        value: function addSeriesAsDrilldown(t, e) {
          var i = this.chart || this;

          if (ta(this, "addSeriesAsDrilldown", {
            seriesOptions: e
          }), i.mapView) {
            if (t.series.isDrilling = !0, i.series.forEach(function (t) {
              var _t$dataLabelsGroup;

              t.options.inactiveOtherPoints = !0, (_t$dataLabelsGroup = t.dataLabelsGroup) !== null && _t$dataLabelsGroup !== void 0 && _t$dataLabelsGroup.destroy(), delete t.dataLabelsGroup;
            }), i.options.drilldown && !i.mapView.projection.hasGeoProjection && P && !tr(ts(i.options.drilldown, P).mapZooming) && (i.options.drilldown.mapZooming = !1), i.options.drilldown && i.options.drilldown.animation && i.options.drilldown.mapZooming) {
              i.mapView.allowTransformAnimation = !0;

              var _o3 = ti(i.options.drilldown.animation);

              if ("boolean" != typeof _o3) {
                var _l5 = _o3.complete,
                    _r5 = function _r5(o) {
                  o && o.applyDrilldown && i.mapView && (i.addSingleSeriesAsDrilldown(t, e), i.applyDrilldown(), i.mapView.allowTransformAnimation = !1);
                };

                _o3.complete = function () {
                  _l5 && _l5.apply(this, arguments), _r5.apply(this, arguments);
                };
              }

              t.zoomTo(_o3);
            } else i.addSingleSeriesAsDrilldown(t, e), i.applyDrilldown();
          } else i.addSingleSeriesAsDrilldown(t, e), i.applyDrilldown();
        }
      }, {
        key: "addSingleSeriesAsDrilldown",
        value: function addSingleSeriesAsDrilldown(t, e) {
          var i = this.chart || this,
              o = t.series,
              l = o.xAxis,
              r = o.yAxis,
              s = i.styledMode ? {
            colorIndex: th(t.colorIndex, o.colorIndex)
          } : {
            color: t.color || o.color
          },
              n = o.options._levelNumber || 0;
          i.drilldownLevels || (i.drilldownLevels = []), e = tn(tn({
            _ddSeriesId: tm++
          }, s), e);
          var a = [],
              d = [],
              p;
          (p = i.drilldownLevels[i.drilldownLevels.length - 1]) && p.levelNumber !== n && (p = void 0), o.chart.series.forEach(function (t) {
            t.xAxis === l && (t.options._ddSeriesId = t.options._ddSeriesId || tm++, t.options.colorIndex = t.colorIndex, t.options._levelNumber = t.options._levelNumber || n, p ? (a = p.levelSeries, d = p.levelSeriesOptions) : (a.push(t), t.purgedOptions = td({
              _ddSeriesId: t.options._ddSeriesId,
              _levelNumber: t.options._levelNumber,
              selected: t.options.selected
            }, t.userOptions), d.push(t.purgedOptions)));
          });
          var h = tn({
            levelNumber: n,
            seriesOptions: o.options,
            seriesPurgedOptions: o.purgedOptions,
            levelSeriesOptions: d,
            levelSeries: a,
            shapeArgs: t.shapeArgs,
            bBox: t.graphic ? t.graphic.getBBox() : {},
            color: t.isNull ? E().parse(s.color).setOpacity(0).get() : s.color,
            lowerSeriesOptions: e,
            pointOptions: t.options,
            pointIndex: t.index,
            oldExtremes: {
              xMin: l && l.userMin,
              xMax: l && l.userMax,
              yMin: r && r.userMin,
              yMax: r && r.userMax
            },
            resetZoomButton: p && p.levelNumber === n ? void 0 : i.resetZoomButton
          }, s);
          i.drilldownLevels.push(h), l && l.names && (l.names.length = 0);
          var u = h.lowerSeries = i.addSeries(e, !1);
          u.options._levelNumber = n + 1, l && (l.oldPos = l.pos, l.userMin = l.userMax = null, r.userMin = r.userMax = null), u.isDrilling = !0, o.type === u.type && (u.animate = u.animateDrilldown || to, u.options.animation = !0);
        }
      }, {
        key: "applyDrilldown",
        value: function applyDrilldown() {
          var _e$pointer2;

          var t;
          var e = this.chart || this,
              i = e.drilldownLevels;
          i && i.length > 0 && (t = i[i.length - 1].levelNumber, e.hasCartesianSeries = i.some(function (t) {
            return t.lowerSeries.isCartesian;
          }), (e.drilldownLevels || []).forEach(function (i) {
            e.mapView && e.options.drilldown && e.options.drilldown.mapZooming && (e.redraw(), i.lowerSeries.isDrilling = !1, e.mapView.fitToBounds(i.lowerSeries.bounds), i.lowerSeries.isDrilling = !0), i.levelNumber === t && i.levelSeries.forEach(function (o) {
              if (e.mapView) {
                if (o.options && o.options._levelNumber === t && o.group) {
                  var _t9 = {};
                  e.options.drilldown && (_t9 = e.options.drilldown.animation), o.group.animate({
                    opacity: 0
                  }, _t9, function () {
                    var _e$pointer;

                    o.remove(!1), i.levelSeries.filter(function (t) {
                      return Object.keys(t).length;
                    }).length || (e.resetZoomButton && (e.resetZoomButton.hide(), delete e.resetZoomButton), (_e$pointer = e.pointer) !== null && _e$pointer !== void 0 && _e$pointer.reset(), ta(e, "afterDrilldown"), e.mapView && (e.series.forEach(function (t) {
                      t.isDirtyData = !0, t.isDrilling = !1;
                    }), e.mapView.fitToBounds(void 0, void 0), e.mapView.allowTransformAnimation = !0), ta(e, "afterApplyDrilldown"));
                  });
                }
              } else o.options && o.options._levelNumber === t && o.remove(!1);
            });
          })), e.mapView || (e.resetZoomButton && (e.resetZoomButton.hide(), delete e.resetZoomButton), (_e$pointer2 = e.pointer) !== null && _e$pointer2 !== void 0 && _e$pointer2.reset(), ta(e, "afterDrilldown"), e.hasCartesianSeries || e.axes.forEach(function (t) {
            t.destroy(!0), t.init(e, td(t.userOptions, t.options));
          }), e.redraw(), ta(e, "afterApplyDrilldown"));
        }
      }, {
        key: "drillUp",
        value: function drillUp(t) {
          var e = this.chart || this;
          if (!e.drilldownLevels || 0 === e.drilldownLevels.length) return;
          ta(e, "beforeDrillUp");

          var i = e.drilldownLevels,
              o = i[i.length - 1].levelNumber,
              l = e.series,
              r = e.drilldownLevels.length,
              s = function s(t, i) {
            var o;
            if (l.forEach(function (e) {
              e.options._ddSeriesId === t._ddSeriesId && (o = e);
            }), (o = o || e.addSeries(t, !1)).type === i.type && o.animateDrillupTo && (o.animate = o.animateDrillupTo), t === p.seriesPurgedOptions) return o;
          },
              n = function n(t) {
            t.remove(!1), e.series.forEach(function (t) {
              t.colorAxis && (t.isDirtyData = !0), t.options.inactiveOtherPoints = !1;
            }), e.redraw();
          },
              a = i.length,
              d,
              p,
              h;

          var _loop = function _loop() {
            var u = void 0,
                c = void 0;

            if ((p = i[a]).levelNumber === o) {
              if (i.pop(), !(u = p.lowerSeries).chart) {
                for (d = l.length; d--;) {
                  if (l[d].options.id === p.lowerSeriesOptions.id && l[d].options._levelNumber === o + 1) {
                    u = l[d];
                    break;
                  }
                }
              }

              u.dataTable.setColumn("x", []), u.xAxis && u.xAxis.names && (0 === r || a === r - 1) && (u.xAxis.names.length = 0), p.levelSeriesOptions.forEach(function (t) {
                var e = s(t, u);
                e && (c = e);
              }), ta(e, "drillup", {
                seriesOptions: p.seriesPurgedOptions || p.seriesOptions
              }), c && (c.type === u.type && (c.drilldownLevel = p, c.options.animation = e.options.drilldown.animation, u.animateDrillupFrom && u.chart && u.animateDrillupFrom(p)), c.options._levelNumber = o);
              var _m2 = u;

              if (e.mapView || _m2.remove(!1), c && c.xAxis && (h = p.oldExtremes, c.xAxis.setExtremes(h.xMin, h.xMax, !1), c.yAxis.setExtremes(h.yMin, h.yMax, !1)), p.resetZoomButton && (e.resetZoomButton = p.resetZoomButton), e.mapView) {
                var _i3 = p.levelNumber === o && t,
                    _l6 = e.options.drilldown && e.options.drilldown.animation && e.options.drilldown.mapZooming;

                _i3 ? u.remove(!1) : (u.dataLabelsGroup && (u.dataLabelsGroup.destroy(), delete u.dataLabelsGroup), e.mapView && c && (_l6 && (u.isDrilling = !0, c.isDrilling = !0, e.redraw(!1), e.mapView.fitToBounds(u.bounds, void 0, !0, !1)), e.mapView.allowTransformAnimation = !0, ta(e, "afterDrillUp", {
                  seriesOptions: c ? c.userOptions : void 0
                }), _l6 ? (e.mapView.setView(void 0, th(e.mapView.minZoom, 1), !0, {
                  complete: function complete() {
                    Object.prototype.hasOwnProperty.call(this, "complete") && n(u);
                  }
                }), c._hasTracking = !1) : (e.mapView.allowTransformAnimation = !1, u.group ? u.group.animate({
                  opacity: 0
                }, e.options.drilldown.animation, function () {
                  n(u), e.mapView && (e.mapView.allowTransformAnimation = !0);
                }) : (n(u), e.mapView.allowTransformAnimation = !0)), c.isDrilling = !1));
              } else ta(e, "afterDrillUp");
            }
          };

          for (e.symbolCounter = e.colorCounter = 0; a--;) {
            _loop();
          }

          e.mapView || e.redraw(), e.ddDupes && (e.ddDupes.length = 0), ta(e, "drillupall");
        }
      }, {
        key: "fadeInGroup",
        value: function fadeInGroup(t) {
          var e = ti(this.chart.options.drilldown.animation);
          t && (t.hide(), tc(function () {
            t && t.added && t.fadeIn();
          }, Math.max(e.duration - 50, 0)));
        }
      }, {
        key: "update",
        value: function update(t, e) {
          var i = this.chart;
          td(!0, i.options.drilldown, t), th(e, !0) && i.redraw();
        }
      }]);

      return tb;
    }();

    !function (t) {
      function e(t) {
        var e = this.chart,
            i = this.getLevel() - t.newLevel,
            o = i > 1;

        for (var _t10 = 0; _t10 < i; _t10++) {
          _t10 === i - 1 && (o = !1), e.drillUp(o);
        }
      }

      function i() {
        var t = this.options.drilldown,
            e = t && t.breadcrumbs;
        this.breadcrumbs || (this.breadcrumbs = new T(this, e)), this.breadcrumbs.updateProperties(tf(this));
      }

      function o() {
        this.breadcrumbs && this.breadcrumbs.updateProperties(tf(this));
      }

      function l() {
        this.drilldown = new tb(this);
      }

      function r() {
        this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy());
      }

      function s() {
        this.resetZoomButton && this.showResetZoom();
      }

      function n() {
        (this.xAxis || []).forEach(function (t) {
          t.ddPoints = {}, t.series.forEach(function (e) {
            var i = e.getColumn("x"),
                o = e.points;

            for (var _l7 = 0, _r6 = i.length, _s4; _l7 < _r6; _l7++) {
              if ("number" != typeof (_s4 = e.options.data[_l7]) && (_s4 = e.pointClass.prototype.optionsToObject.call({
                series: e
              }, _s4)).drilldown) {
                t.ddPoints[i[_l7]] || (t.ddPoints[i[_l7]] = []);

                var _r7 = _l7 - (e.cropStart || 0);

                t.ddPoints[i[_l7]].push(!o || !(_r7 >= 0) || !(_r7 < o.length) || o[_r7]);
              }
            }
          }), tp(t.ticks, function (t) {
            return t.drillable();
          });
        });
      }

      function a(t) {
        var e = this.breadcrumbs,
            i = t.options.drilldown && t.options.drilldown.breadcrumbs;
        e && i && e.update(i);
      }

      function d(t) {
        this.attr({
          opacity: .1,
          visibility: "inherit"
        }).animate({
          opacity: th(this.newOpacity, 1)
        }, t || {
          duration: 250
        });
      }

      function p() {
        var t = this.pos,
            e = this.label,
            i = this.axis,
            o = "xAxis" === i.coll && i.getDDPoints,
            l = o && i.getDDPoints(t),
            r = i.chart.styledMode;
        o && (e && l && l.length ? (e.drillable = !0, e.basicStyles || r || (e.basicStyles = td(e.styles)), e.addClass("highcharts-drilldown-axis-label"), e.removeOnDrillableClick && tu(e.element, "click"), e.removeOnDrillableClick = tl(e.element, "click", function (e) {
          e.preventDefault(), i.drilldownCategory(t, e);
        }), !r && i.chart.options.drilldown && e.css(i.chart.options.drilldown.activeAxisLabelStyle || {})) : e && e.drillable && e.removeOnDrillableClick && (r || (e.styles = {}, e.element.removeAttribute("style"), e.css(e.basicStyles)), e.removeOnDrillableClick(), e.removeClass("highcharts-drilldown-axis-label")));
      }

      t.compose = function (t, h, u, c, m, w, g) {
        te.compose(c, m);
        var f = h.prototype;

        if (!f.drillUp) {
          var _c2 = w.prototype.Element,
              _m3 = tb.prototype,
              _b = t.prototype,
              _v = _c2.prototype,
              _y = g.prototype;
          _b.drilldownCategory = tw, _b.getDDPoints = tg, T.compose(h, u), tl(T, "up", e), f.addSeriesAsDrilldown = _m3.addSeriesAsDrilldown, f.addSingleSeriesAsDrilldown = _m3.addSingleSeriesAsDrilldown, f.applyDrilldown = _m3.applyDrilldown, f.drillUp = _m3.drillUp, tl(h, "afterDrilldown", i), tl(h, "afterDrillUp", o), tl(h, "afterInit", l), tl(h, "drillup", r), tl(h, "drillupall", s), tl(h, "render", n), tl(h, "update", a), u.drilldown = P, _v.fadeIn = d, _y.drillable = p;
        }
      };
    }(o || (o = {}));
    var tv = o,
        ty = d();
    ty.Breadcrumbs = ty.Breadcrumbs || T, tv.compose(ty.Axis, ty.Chart, ty.defaultOptions, ty.Series, ty.seriesTypes, ty.SVGRenderer, ty.Tick);
    var tx = d();
    return n.default;
  }();
});